<script>
export default {
    name: "InterimBillPrint",

    data() {

        return {
            dischargeDetails: {
              patientsPayments: [],
              patientWardCharges: [],
              patientDrugsnService: [],
              patientsDeposits: [],
            },
            patient: {},
            dischargeSummary: {},
            dateGenerated: window.moment()
        };
    },

    computed: {

        totalBedCharges() {
            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientWardCharges) return 0;

            if(!this.dischargeDetails.patientWardCharges.length) return 0;

            if(this.dischargeDetails.patientWardCharges.filter(charge => charge.discharged).length) return 0;
            
            return this.dischargeDetails.patientWardCharges
                .map(wCharge => wCharge.amount ? parseFloat(wCharge.amount) : 0 )
                .reduce((sum, amt) => sum+amt);
        },

        totalDrugsAndServices() {

            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientDrugsnService) return 0;

            if(!this.dischargeDetails.patientDrugsnService.length) return 0;

            return this.dischargeDetails.patientDrugsnService
                .map(drugCharges => drugCharges.grandTotal ? parseFloat(drugCharges.grandTotal) : 0)
                .reduce((sum, amt) => sum+amt);
        },

        totalBill() {

            return this.totalDrugsAndServices + this.totalBedCharges;
        },

        totalDeposits() {
            if(!this.dischargeDetails) return 0;
            
            if(!this.dischargeDetails.patientsDeposits) return 0;

            if(!this.dischargeDetails.patientsDeposits.length) return 0;
            
            return this.dischargeDetails.patientsDeposits.map(dep => 
                dep.depositAmount ? parseFloat(dep.depositAmount) : 0)
                .reduce((sum, amt) => sum+amt);
        },

        totalDepositAllocated() {
            if(!this.dischargeDetails) return 0;
            
            if(!this.dischargeDetails.patientsDeposits) return 0;

            if(!this.dischargeDetails.patientsDeposits.length) return 0;
            
            return this.dischargeDetails.patientsDeposits.map(dep => 
                dep.amountAllocated ? parseFloat(dep.amountAllocated) : parseFloat(0))
                .reduce((sum, amt) => sum+amt);
        },

        totalDepositUnallocated() {
            if(!this.dischargeDetails) return 0;
            
            if(!this.dischargeDetails.patientsDeposits) return 0;

            if(!this.dischargeDetails.patientsDeposits.length) return 0;
            
            return this.dischargeDetails.patientsDeposits.map(dep => 
                    dep.unAllocatedAmount ? parseFloat(dep.unAllocatedAmount) : parseFloat(0))
                .reduce((sum, amt) => sum+amt);
        },

        totalPayments() {

            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientsPayments) return 0;

            if(!this.dischargeDetails.patientsPayments.length) return 0;

            return this.dischargeDetails.patientsPayments
                .map(payment => payment.receiptAmount ? parseFloat(payment.receiptAmount) : 0)
                .reduce((sum, amt) => sum+amt);
        },

        totalPaidAmt() {

            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientDrugsnService) return 0;

            if(!this.dischargeDetails.patientDrugsnService.length) return 0;

            return this.dischargeDetails.patientDrugsnService
                .map(drugCharges => drugCharges.paid ? parseFloat(drugCharges.paid) : 0)
                .reduce((sum, amt) => sum+amt);
        },

        totalDSBalance() {

            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientDrugsnService) return 0;

            if(!this.dischargeDetails.patientDrugsnService.length) return 0;

            return this.dischargeDetails.patientDrugsnService
                .map(drugCharges => drugCharges.balance ? parseFloat(drugCharges.balance) : 0)
                .reduce((sum, amt) => sum+amt);
        },

        totalPaymentReceived() {
            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientsPayments) return 0;

            if(!this.dischargeDetails.patientsPayments.length) return 0;

            return this.dischargeDetails.patientsPayments.map(payment => parseFloat(payment.receiptAmount))
                .reduce((sum,amt) => sum+amt);
        },

        totalWaiver() {
            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientsWeivers) return 0;

            if(!this.dischargeDetails.patientsWeivers.length) return 0;
            
            return this.dischargeDetails.patientsWeivers
                    .map(waiver => parseFloat(waiver.weiveredAmount))
                    .reduce((sum,amt) => sum+amt);
        },

        totalOrganizationReceipts() {
            if(!this.dischargeDetails) return 0;

            if(!this.dischargeDetails.patientOrganReceipts) return 0;

            if(!this.dischargeDetails.patientOrganReceipts.length) return 0;

            return this.dischargeDetails.patientOrganReceipts
                    .map(orgPayment => parseFloat(orgPayment.amount))
                    .reduce((sum,amt) => sum+amt);
        },

        totalBalance() {
          return this.totalBill - (this.totalPaidAmt + this.totalDepositUnallocated);
        },
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ 
            this.fetchDischargeDetails(), this.fetchPatient(), this.fetchDischargeSummary(),
        ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchDischargeDetails() {
            let url = `Morgue/GetMorgueInterimBill`;
                url += `?PatientID=${this.$route.query.patientID}`;
                url += `&VisitNo=${this.$route.query.visitNo}`;

            return this.$http.get(url).then(({ data }) => {
                this.dischargeDetails = data;
            }).catch(() => {});
        },

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.query.patientID}`;

            return this.$http.get(url).then(({ data }) => {
              this.patient = data.length ? data[0] : {};
            }).catch(() => {});
        },

        fetchDischargeSummary() {
            let url = `Admissions/GetPatientDischargeSummary`;
                url += `?PatientID=${this.$route.query.patientID}`;
                url += `&VisitNo=${this.$route.query.visitNo}`;

          return this.$http.get(url).then(response => { 
                this.dischargeSummary = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="w-full p-1 text-center">
            <h5 class="font-bold uppercase">Patient Hospital Bill Summary</h5>
        </div>
        <div class="w-full flex flex-wrap text-sm mt-3">
            <div class="w-1/4 p-1">
                <h5 class="font-medium">Name: {{ patient.names }}</h5>
            </div>
            <div class="w-1/4 p-1">
                <h5 class="font-medium">MRN: {{ patient.patienT_ID }}</h5>
            </div>
            <div class="w-1/4 p-1">
                <h5 class="font-medium">IP NO: {{ patient.ipfileno }}</h5>
            </div>
            <div class="w-1/4 p-1">
                <h5 class="font-medium">OP NO: {{ patient.opfileno || `-` }}</h5>
            </div>
            <div class="w-1/4 p-1">
                <h5 class="font-medium">Cellphone: {{ patient.celL_PHONE }}</h5>
            </div>
            <div class="w-1/4 p-1">
                <h5 class="font-medium">ID No: {{ patient.nationalid || `-` }}</h5>
            </div>
            <div class="w-1/4 p-1">
                <h5 class="font-medium">Admitted On: 
                    {{ dischargeDetails.patientWardCharges.length ? 
                        $root.formatDate(dischargeDetails.patientWardCharges[0].bedDateIn) : `-` }}
                </h5>
            </div>
            <div class="w-1/4 p-1">
                <h5 class="font-medium">Discharged On: 
                    {{ 
                      (totalBedCharges == 0 &&
                      dischargeDetails.patientWardCharges &&
                      dischargeDetails.patientWardCharges.length)
                        ? $root.formatDate(
                            dischargeDetails.patientWardCharges[dischargeDetails.patientWardCharges.length-1].bedDateOut
                          )
                        : `-`
                    }}
                </h5>
            </div>
            <div class="w-1/3 p-1">
                <h5 class="font-medium">Generated Time: 
                    {{ dateGenerated | dateFormatDT }}
                </h5>
            </div>
        </div>
        <div class="w-full p-1 my-1">
            <h5 class="font-medium">Payment Mode: {{ patient.pMode }}</h5>
        </div>
        <div class="w-full p-1 my-1">
            <h5 class="font-bold">Diagnosis: {{ dischargeSummary.diagnosis || `-` }}</h5>
        </div>
        <div class="w-full p-1 text-center">
            <h5 class="font-bold text-base">Daily Charges</h5>
        </div>
        <div class="w-full">
            <table class="table table-bordered">
                <tbody class="text-xs">
                    <tr>
                        <th class="p-tiny">Ward Type</th>
                        <th class="p-tiny">Ward</th>
                        <th class="p-tiny">Bed</th>
                        <th class="p-tiny">Bed Date In</th>
                        <th class="p-tiny">Bed Date Out</th>
                        <th class="p-tiny">Days</th>
                        <th class="p-tiny">Daily Charge</th>
                        <th class="p-tiny">Amount</th>
                    </tr>
                    <tr v-for="(wardCharge,idx) in dischargeDetails.patientWardCharges" :key="idx">
                        <td class="p-tiny">{{ wardCharge.ward_Type }}</td>
                        <td class="p-tiny">{{ wardCharge.ward }}</td>
                        <td class="p-tiny">{{ wardCharge.bed }}</td>
                        <td class="p-tiny">{{ wardCharge.bedDateIn | dateFormat }}</td>
                        <td class="p-tiny">{{ wardCharge.bedDateOut | dateFormat }}</td>
                        <td class="p-tiny">{{ wardCharge.days }}</td>
                        <td class="p-tiny">{{ wardCharge.daily_Charge | numberFormat }}</td>
                        <td class="p-tiny">{{ wardCharge.amount | numberFormat }}</td>
                    </tr>
                    <tr>
                        <td colspan="7"></td>
                        <td colspan="1" class="p-tiny">
                            Total:
                            <span 
                                v-if="(dischargeDetails.patientWardCharges.length && totalBedCharges == 0)">
                                Charges Posted</span>
                            <span v-else>{{ totalBedCharges | numberFormat }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="w-full p-1 text-center">
            <h5 class="font-bold text-base">Drugs & Services</h5>
        </div>
        <div class="w-full overflow-auto">
            <table class="table table-bordered">
                <tbody class="text-xs">
                    <tr>
                        <th class="p-tiny">Date</th>
                        <th class="p-tiny">Item</th>
                        <th class="p-tiny">Consultant</th>
                        <th class="p-tiny">Price</th>
                        <th class="p-tiny">Qty</th>
                        <th class="p-tiny">Total</th>
                        <th class="p-tiny">paid</th>
                        <th class="p-tiny">Balance</th>
                        <th class="p-tiny">Billed</th>
                    </tr>
                    <tr 
                        v-for="(drugCharges, idx) in dischargeDetails.patientDrugsnService" 
                        :class="drugCharges.isCash == `0` ? `` : `border-2 border-gray-500`"
                        :key="idx">
                        <td class="p-tiny">{{ drugCharges.txnDate | dateFormat }}</td>
                        <td class="p-tiny">{{ drugCharges.service }}</td>
                        <td class="p-tiny">{{ drugCharges.consultant }}</td>
                        <td class="p-tiny">{{ drugCharges.charge | numberFormat }}</td>
                        <td class="p-tiny">{{ drugCharges.quantity }}</td>
                        <td class="p-tiny">{{ drugCharges.grandTotal | numberFormat }}</td>
                        <td class="p-tiny">{{ drugCharges.paid | numberFormat }}</td>
                        <td class="p-tiny">{{ drugCharges.balance | numberFormat }}</td>
                        <td class="p-tiny">{{ drugCharges.billed ? `Yes` : `No` }}</td>
                    </tr>
                    <tr class="font-medium">
                        <td class="p-tiny text-right" colspan="5">Totals:</td>
                        <td class="p-tiny">{{ totalDrugsAndServices | numberFormat }}</td>
                        <td class="p-tiny">{{ totalPaidAmt | numberFormat }}</td>
                        <td class="p-tiny">{{ totalDSBalance | numberFormat }}</td>
                        <td class="p-tiny"></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="w-full p-1 text-center">
            <h5 class="font-bold text-base">Deposits Received</h5>
        </div>
        <div class="w-full">
            <table class="table table-bordered">
                <tbody class="text-xs">
                    <tr>
                        <th class="p-tiny">TRX Date</th>
                        <th class="p-tiny">Receipt No</th>
                        <th class="p-tiny">Type</th>
                        <th class="p-tiny">Mode</th>
                        <th class="p-tiny">Amount</th>
                        <th class="p-tiny">Allocated</th>
                        <th class="p-tiny">Un-allocated</th>
                        <th class="p-tiny">User</th>
                    </tr>
                    <tr v-for="(patientDeposit, idx) in dischargeDetails.patientsDeposits" :key="idx">
                        <td class="p-tiny">{{ patientDeposit.trxDate | dateFormat }}</td>
                        <td class="p-tiny">{{ patientDeposit.receiptNo }}</td>
                        <td class="p-tiny">{{ patientDeposit.paymentType }}</td>
                        <td class="p-tiny">{{ patientDeposit.mode }}</td>
                        <td class="p-tiny">{{ patientDeposit.depositAmount | numberFormat }}</td>
                        <td class="p-tiny">{{ patientDeposit.amountAllocated | numberFormat }}</td>
                        <td class="p-tiny">{{ patientDeposit.unAllocatedAmount | numberFormat }}</td>
                        <td class="p-tiny">{{ patientDeposit.userName}}</td>
                    </tr>
                    <tr class="font-medium">
                        <td class="p-tiny text-right" colspan="4">Totals:</td>
                        <td class="p-tiny">{{ totalDeposits | numberFormat }}</td>
                        <td class="p-tiny">{{ totalDepositAllocated | numberFormat }}</td>
                        <td class="p-tiny">{{ totalDepositUnallocated | numberFormat }}</td>
                        <td class="p-tiny"></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="w-full p-1 text-center">
            <h5 class="font-bold text-base">Payments Received</h5>
        </div>
        <div class="w-full">
            <table class="table table-bordered">
                <tbody class="text-xs">
                    <tr>
                        <th class="p-tiny">Date</th>
                        <th class="p-tiny">Receipt No</th>
                        <th class="p-tiny">Mode</th>
                        <th class="p-tiny">Paid Amount</th>
                        <th class="p-tiny">Credit Amt</th>
                        <th class="p-tiny">Receipt Amt</th>
                    </tr>
                    <tr v-for="(paymentReceived, idx) in dischargeDetails.patientsPayments" :key="idx">
                        <td class="p-tiny">{{ paymentReceived.date | dateFormat }}</td>
                        <td class="p-tiny">{{ paymentReceived.receipt_No }}</td>
                        <td class="p-tiny">{{ paymentReceived.mode }}</td>
                        <td class="p-tiny">{{ paymentReceived.amount | numberFormat }}</td>
                        <td class="p-tiny">{{ paymentReceived.creditAmount | numberFormat }}</td>
                        <td class="p-tiny">{{ paymentReceived.receiptAmount | numberFormat }}</td>
                    </tr>
                    <tr class="font-medium">
                        <td class="p-tiny" colspan="4"></td>
                        <td class="p-tiny text-right">Total:</td>
                        <td class="p-tiny">{{ totalPaymentReceived | numberFormat }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="w-full text-base my-1 text-center">
                <h5 class="font-bold text-base">Waiver Bills</h5>
            </div>
            <div class="w-full my-2">
                <table class="table">
                    <tbody class="flex text-xs flex-col items-center">
                        <tr class="w-full flex">
                            <th class="p-tiny flex-1">Date</th>
                            <th class="p-tiny flex-1">Bill No</th>
                            <th class="p-tiny w-1/4">Item</th>
                            <th class="p-tiny flex-1">Price</th>
                            <th class="p-tiny flex-1">Qty</th>
                            <th class="p-tiny flex-1">Total</th>
                            <th class="p-tiny flex-1">Waivered</th>
                        </tr>
                        <tr class="flex w-full" 
                            v-for="(waiver, idx) in dischargeDetails.patientsWeivers" :key="idx">
                            <td class="p-tiny flex-1">{{ waiver.txnDate | dateFormat }}</td>
                            <td class="p-tiny flex-1">{{ waiver.billNo }}</td>
                            <td class="p-tiny w-1/4">{{ waiver.service }}</td>
                            <td class="p-tiny flex-1">{{ waiver.charge | numberFormat }}</td>
                            <td class="p-tiny flex-1">{{ waiver.quantity }}</td>
                            <td class="p-tiny flex-1">{{ waiver.lineTotal | numberFormat }}</td>
                            <td class="p-tiny flex-1">{{ waiver.weiveredAmount | numberFormat }}</td>
                        </tr>
                        <tr class="font-medium">
                            <td class="p-tiny text-right" colspan="6">Total:</td>
                            <td class="p-tiny">{{ totalWaiver | numberFormat }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="w-full text-center p-1">
                <h5 class="text-base font-semibold">
                    Bill To Insurance, Companies Or Organization</h5>
            </div>
            <div class="w-full">
                <table class="table text-sm">
                    <tbody>
                        <tr>
                            <th class="p-tiny">Billed To</th>
                            <th class="p-tiny">Invoice Date</th>
                            <th class="p-tiny">Invoice No</th>
                            <th class="p-tiny">Amount</th>
                        </tr>
                        <tr v-for="(bill,idx) in dischargeDetails.patientOrganReceipts" :key="idx">
                            <td class="p-tiny">{{ bill.billTo }}</td>
                            <td class="p-tiny">{{ bill.invoiceDate | dateFormat }}</td>
                            <td class="p-tiny">{{ bill.invoiceNo }}</td>
                            <td class="p-tiny">{{ bill.amount | numberFormat }}</td>
                        </tr>
                        <tr class="font-medium">
                            <td colspan="3" class="p-tiny text-right">Total:</td>
                            <td class="p-tiny">{{ totalOrganizationReceipts | numberFormat }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex flex-row content-start p-1 my-2">
                <div class="flex-1">
                    <h5 class="font-bold">Total Bill: {{ totalBill | numberFormat }}</h5>
                </div>
                <div class="flex-1">
                    <h5 class="font-bold">Payments Made: {{ (totalPaidAmt + totalDepositUnallocated) | numberFormat }}</h5>
                </div>
                <div class="flex-1">
                    <h5 class="font-bold">This Visit Balance: {{ totalBalance | numberFormat }}</h5>
                </div>
                <div class="flex-1">
                  <h5 class="font-bold">
                    Overall Balance: {{ (dischargeDetails.totalBalance + totalBedCharges - totalDepositUnallocated) | numberFormat }}
                  </h5>
                </div>
            </div>
        </div>
    </div>
</template>